import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React from 'react';
import { injectIntl, intlShape } from "react-intl";
import { Switch } from 'react-router-dom';
import * as constants from "../../../util/constants";
import Alert from "../../common/Alert";
import Breadcrumb from "../../common/Breadcrumb";
import ModalPhrase from "../../common/ModalPhrase";
import NavListItem from "../../common/NavListItem";
import PrivateRoute from "../../common/PrivateRoute";
import Propertii from "../../common/Propertii";
import Merchants from "./Merchants";
import Notes from './Notes';
import Property from "./Property";
import ServiceLevelConfig from "./ServiceLevelConfig";
import Syncs from "./Syncs";
import Tenants from "./Tenants";
import Transactions from "./Transactions";

class Navigation extends Propertii {

    /**
     * Initialize the component.
     *
     * @param props - The properties of the component.
     */
    constructor(props) {

        super(props);

        this.state = {
            property: {},
            company: {},
            parentCompany: {},
            validationList: [],
        };

        this.refreshProperty = this.refreshProperty.bind(this);
        this.deleteProperty = this.deleteProperty.bind(this);
        this.viewCompany = this.viewCompany.bind(this);
    }

    /**
     * Get the property based on the ID provided in the route.
     */
    componentDidMount() {
        this.refreshProperty(this.props.match.params.propertyId);
    }

    /**
     * Delete the property currently being viewed.
     */
    deleteProperty() {

        axios.delete(`${constants.REACT_APP_HOST_API_URL}/property/${this.props.match.params.propertyId}/delete`, {
            headers: this.generateRequestHeaders()
        }).then(response => {
            this.props.history.push({
                pathname: `/admin/properties`,
                state: {
                    validationList: [{
                        fields: {},
                        alert: {
                            type: 'primary',
                            code: 'admin.properties.deleted',
                            message: 'Property has been deleted'
                        }
                    }],
                }
            });
        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Redirect the user to the relevant company view component.
     */
    viewCompany() {

        this.props.history.push({
            pathname: `/admin/${this.state.property.joins.company.landlordId ? 'landlords' : 'companies'}/${this.state.property.joins.company.landlordId ? this.state.property.joins.company.landlordId : this.state.property.companyId}/edit`,
        });
    }

    /**
     * Force a refresh of this component if required by a child component. Because this component displays the
     * property's name or street address in the breadcrumbs, this component should update if a child component makes an
     * update to said values.
     *
     * @param propertyId - The ID of the property to fetch data from.
     */
    refreshProperty(propertyId) {

        this.setState(prevState => ({
            spinner: true
        }));

        axios.post(`${constants.REACT_APP_HOST_API_URL}/property/search`, {
            orderBy: 'ASC',
            orderByFields: ['createDate'],
            conditionList: [
                {
                    type: 'STRING',
                    logicalOperator: 'AND',
                    openBrackets: null,
                    closeBrackets: null,
                    fieldName: 'id',
                    operator: 'EQUALS',
                    fieldValue: propertyId
                }
            ],
            joins: {
                company: {
                    targetRecordType: 'TYPE_COMPANY',
                    joinField: 'companyId',
                    alias: 'company',
                    returnFields: ['name','landlordId', 'id', 'customCard','notificationProvider']
                },
                parentComp: {
                    targetRecordType: 'TYPE_COMPANY',
                    joinField: 'company.parentId',
                    alias: 'parentComp',
                    returnFields: ['id', 'name', 'customCard']
                }
            }
        }, {
            headers: this.generateRequestHeaders()
        }).then(response => {

            const property = response.data.records[0];

            if(property.joins.parentComp){
                this.setState(prevState => ({
                    ...prevState,
                    spinner: false,
                    property: property,
                    company: property.joins.company,
                    parentCompany: property.joins.parentComp
                }));
            } else {
                this.setState(prevState => ({
                    ...prevState,
                    spinner: false,
                    property: property,
                    company: property.joins.company
                }));
            }

        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Render the component.
     *
     * @returns {*} - The view property component for landlords.
     */
    render() {

        return(
            <div className="content-block">

                <div className="container">

                    <Breadcrumb parentPath="/admin/properties" parentPage="Properties" childPage={`${this.state.property.propertyName ? this.state.property.propertyName : this.state.property.street1}`} />

                    <Alert validationList={this.state.validationList} />

                    <div className="row">
                        <div className="col-md-4">

                            <div className="card">

                                <div className="card-header">
                                    Options
                                </div>

                                <div className="card-body card-body-list">
                                    <div className="list-group">

                                        <NavListItem path={`/admin/properties/${this.props.match.params.propertyId}/edit`} active="edit" size="small" iconName="building" name="Property" />
                                        <NavListItem path={`/admin/properties/${this.props.match.params.propertyId}/tenants`} active="tenants" size="small" iconName="users" name="Tenants" />
                                        <NavListItem path={`/admin/properties/${this.props.match.params.propertyId}/transactions`} active="transactions" size="small" iconName="credit-card" name="Transactions" />
                                        <NavListItem path={`/admin/properties/${this.props.match.params.propertyId}/merchants`} active="merchants" size="small" iconName="university" name="Merchant Accounts" />
                                        <NavListItem path={`/admin/properties/${this.props.match.params.propertyId}/servicelevelconfig`} active="servicelevelconfig" size="small" iconName="file-invoice-dollar" name="Service Level Configuration" />
                                        <NavListItem path={`/admin/properties/${this.props.match.params.propertyId}/notes`} active="Notes" size="small" iconName="sticky-note" name="Notes" />
                                        {/*<NavListItem path={`/admin/properties/${this.props.match.params.propertyId}/syncs`} active="Syncs" size="small" iconName="sync" name="Syncs" />*/}

                                        <div className="list-group-item list-group-item-action c-pointer" data-toggle="modal" data-target="#delete-property">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="">
                                                    <FontAwesomeIcon icon={['fas', 'trash']} className="fa-fw va-b mr-2" />
                                                    Delete Property
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                            {this.state.property.joins &&
                            <div className="jumbotron border py-4">
                                <div className="container">

                                    <p className="mb-0">
                                        {this.state.property.propertyName ? this.state.property.propertyName : this.state.property.street1} is managed by <span className="btn-link c-pointer font-weight-bold" onClick={() => this.viewCompany()}>{this.state.property.joins.company.name}</span>.
                                    </p>

                                </div>
                            </div>
                            }

                            <ModalPhrase id="delete-property" title="Delete Property" iconName="exclamation-triangle" confirmPhrase="DELETE" handleSuccess={() => this.deleteProperty()}>

                                <p className="">Deleting this property will have the following effects:</p>

                                <ul className="small">
                                    <li>Managers currently overseeing this property will no longer have access to the property information</li>
                                    <li>All property leases associated with this property will be deleted</li>
                                    <li>All scheduled one time payments for this property will be deleted</li>
                                    <li>All auto payments being made for this property will be deleted</li>
                                    <li>Historical transactions made to this property will no longer display the property information</li>
                                </ul>

                                <p className="mb-0">To delete this property, enter the phrase 'DELETE' in the field below, then click the Confirm button.</p>

                            </ModalPhrase>

                        </div>
                        <div className="col-md-8">

                            <Switch>
                                <PrivateRoute exact path="/admin/properties/:propertyId/edit" type="TYPE_ADMIN" parent={this} component={Property} refreshProperty={(propertyId) => this.refreshProperty(propertyId)} />
                                <PrivateRoute exact path="/admin/properties/:propertyId/tenants" type="TYPE_ADMIN" parent={this} component={Tenants} property={this.state.property} />
                                <PrivateRoute exact path="/admin/properties/:propertyId/transactions" type="TYPE_ADMIN" parent={this} component={Transactions} property={this.state.property} company={this.state.company}/>
                                <PrivateRoute exact path="/admin/properties/:propertyId/merchants" type="TYPE_ADMIN" parent={this} component={Merchants} />
                                <PrivateRoute exact path="/admin/properties/:propertyId/servicelevelconfig" type="TYPE_ADMIN" parent={this} component={ServiceLevelConfig} property={this.state.property} refreshProperty={(propertyId) => this.refreshProperty(propertyId)}/>
                                <PrivateRoute exact path="/admin/properties/:propertyId/notes" type="TYPE_ADMIN" parent={this} component={Notes} propertyId={this.state.property.id} companyId={this.state.property.companyId}/>
                                <PrivateRoute exact path="/admin/properties/:propertyId/syncs" type="TYPE_ADMIN" parent={this} component={Syncs} property={this.state.property}/>
                            </Switch>

                        </div>
                    </div>

                </div>

            </div>
        )
    };
}

Navigation.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Navigation);